module.exports = __webpack_public_path__ + "img/cf_friend.16987b37.png";